"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RefusedBloodDonorFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../../fields");

var _refusedBloodDonorConfig = require("./refusedBloodDonorConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("refusedBlood", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"].param("_arg1", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]())))));

var RefusedBloodDonorFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RefusedBloodDonorFields, _React$Component);

  var _super = (0, _createSuper2["default"])(RefusedBloodDonorFields);

  function RefusedBloodDonorFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, RefusedBloodDonorFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onChange = function () {
      var _this$props = _this.props,
          refusedBlood = _this$props.refusedBlood,
          componentKey = _this$props.componentKey,
          resetFields = _this$props.resetFields;
      var refusedBloodPath = "".concat(componentKey);
      var field = "".concat(refusedBloodPath, ".reason");

      if (refusedBlood) {
        resetFields(refusedBloodPath, field);
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(RefusedBloodDonorFields, [{
    key: "render",
    value: function render() {
      var refusedBlood = this.props.refusedBlood;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_fields.Radio, {
        key: _refusedBloodDonorConfig.refusedBloodDonorOption.key,
        radio: _refusedBloodDonorConfig.refusedBloodDonorOption,
        id: _refusedBloodDonorConfig.refusedBloodDonorOption.key,
        onChange: this.onChange,
        noOptionalLabel: true
      }), refusedBlood && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
        key: _refusedBloodDonorConfig.refusedBloodDonorReason.key,
        id: _refusedBloodDonorConfig.refusedBloodDonorReason.key,
        textfield: _refusedBloodDonorConfig.refusedBloodDonorReason,
        noOptionalLabel: true
      }));
    }
  }]);
  return RefusedBloodDonorFields;
}(_react["default"].Component);

exports.RefusedBloodDonorFields = RefusedBloodDonorFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    refusedBlood: selector(state, "".concat(componentKey, ".option"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetFields: function resetFields(refusedBloodPath, field) {
      Promise.all([dispatch((0, _reduxForm.change)('form', refusedBloodPath, '')), dispatch((0, _reduxForm.untouch)('form', field))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RefusedBloodDonorFields);

exports["default"] = _default;